<template>
  <div v-if="newReservations">
    <v-badge dot inline color="red">{{ text }}</v-badge>
  </div>
  <div v-else>
    {{ text }}
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapCacheActions } from 'vuex-cache';

export default {
  name: 'BookingBadge',

  components: {},

  props: {
    text: {
      type: String,
      required: true
    }
  },

  data: () => ({}),

  computed: {
    ...mapState('reservations_new_status_badge', ['newReservations'])
  },
  mounted() {
    this.getActualQuantityNewReservations();
  },

  created() {
    this.getQuantityNewReservations();
  },

  methods: {
    ...mapCacheActions('reservations_new_status_badge', [
      'getActualQuantityNewReservations',
      'getQuantityNewReservations'
    ])
  }
};
</script>
